/**
 * 文件说明:
 *
 * utils
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import config from 'config'
import {pathToRegexp} from 'path-to-regexp'
import {parse} from 'qs'
import {get} from 'lodash'
import constants from 'common/constants'
import numeral from 'numeral'
import {Storage} from './storage'

const {dateFormat} = constants

export {
    createMemoizeCache,
    format,
    winSafeOpen as winOpen,
    urlReg,
    isUrl,
    emojiRe,
    isEmojiCharacter,
    ipReg,
    validateIP,
    domainReg,
    addReferrerMeta,
} from '@huzan/hz-utils'

export function getUrlQuery(url = get(window, 'location.search', '')) {
    return parse(url.split('?')[1] || '')
}

export function isPromise(obj) {
    return (
        !!obj &&
        (typeof obj === 'object' || typeof obj === 'function') &&
        typeof obj.then === 'function'
    )
}

export function findInnerChild(item) {
    if (item?.children?.[0]) {
        return findInnerChild(item?.children?.[0])
    }

    return item?.url ?? ''
}

export function checkPathList(item, pathnameList) {
    return pathnameList.find((pathname) => checkPath(item, pathname))
}

export function checkPath(item = '', pathname = '') {
    return pathToRegexp(item).test(pathname)
}

export function treeForEach(treeData, cb, parent) {
    treeData.forEach((data) => {
        cb(data, parent)
        if (data.children) {
            treeForEach(data.children, cb, data)
        }
    })
}

const tokenStore = new Storage()

export function getTokenForStorage() {
    return tokenStore.getItem(config.accessTokenKey)
}

export function hasTokenForStorage() {
    const token = getTokenForStorage()

    return !!token
}

export function removeTokenForStorage() {
    return tokenStore.removeItem(config.accessTokenKey)
}

export function setTokenForStorage(token) {
    return tokenStore.setItem(config.accessTokenKey, token)
}

export function urlToList(url) {
    const urllist = url.split('/').filter((i) => i)
    return urllist.map((urlItem, index) => `/${urllist.slice(0, index + 1).join('/')}`)
}

export function getWXThumbnail(url) {
    if (url && typeof url === 'string') {
        if (url.includes('wx') && url.endsWith('/0')) {
            return `${url.substring(0, url.length - 2)}/96`
        }
        return url
    }
}

export const sizeof = function (str, charset) {
    let total = 0
    let charCode
    let i
    let len
    charset = charset ? charset.toLowerCase() : ''
    if (charset === 'utf-16' || charset === 'utf16') {
        for (i = 0, len = str.length; i < len; i++) {
            charCode = str.charCodeAt(i)
            if (charCode <= 0xffff) {
                total += 2
            } else {
                total += 4
            }
        }
    } else {
        for (i = 0, len = str.length; i < len; i++) {
            charCode = str.charCodeAt(i)
            if (charCode <= 0x007f) {
                total += 1
            } else if (charCode <= 0x07ff) {
                total += 2
            } else if (charCode <= 0xffff) {
                total += 3
            } else {
                total += 4
            }
        }
    }
    return total
}

export function isMac() {
    return /Mac/.test(window.navigator.platform)
}

export function isWXWorkApp() {
    const {userAgent} = window.navigator
    return userAgent.indexOf('MicroMessenger') !== -1 && userAgent.indexOf('wxwork') !== -1
}

export function isMacWXWorkApp() {
    return isMac() && isWXWorkApp()
}

// 列表接口格式化时间和分页请求参数
export function formatTableParams(tableList) {
    const {params, pagination} = tableList
    const newParams = {...params}
    if (params?.create_time?.length) {
        if (typeof params.create_time[0] === 'string') {
            newParams.start_time = `${params.create_time[0]} 00:00:00` || undefined
            newParams.end_time = `${params.create_time[1]} 23:59:59` || undefined
        } else {
            newParams.start_time =
                `${params.create_time[0].format(dateFormat)} 00:00:00` || undefined
            newParams.end_time = `${params.create_time[1].format(dateFormat)} 23:59:59` || undefined
        }

        delete newParams.create_time
    }

    if (pagination) {
        newParams.offset = pagination.pageSize * (pagination.current - 1)
        newParams.limit = pagination.pageSize
    }

    return newParams
}

export function getCount(count, defaultCount = 0) {
    if (typeof count === 'number') {
        return count
    }
    if (typeof count === 'string') {
        const num = Number(count)
        return Number.isNaN(num) ? defaultCount : num
    }
    return defaultCount
}

export function formatNumber(num, format = '0,0') {
    return numeral(num).format(format)
}

export function getPercent(rate, format = '0[.]00%') {
    const count = getCount(rate)
    return numeral(count).format(format)
}
